var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544 32H432L400 0H320C302.375 0 288 14.375 288 32V192C288 209.625 302.375 224 320 224H544C561.625 224 576 209.625 576 192V64C576 46.375 561.625 32 544 32ZM544 320H432L400 288H320C302.375 288 288 302.375 288 320V480C288 497.625 302.375 512 320 512H544C561.625 512 576 497.625 576 480V352C576 334.375 561.625 320 544 320ZM64 16C64 7.125 56.875 0 48 0H16C7.125 0 0 7.125 0 16V416C0 433.625 14.375 448 32 448H256V384H64V160H256V96H64V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTree);
export default __webpack_public_path__ + "static/media/folder-tree.2ada996469ee0d5dfe06614619188055.svg";
export { ForwardRef as ReactComponent };